// Generated by scripts/generate-build-info.ts — do not edit
export const buildInfo = {
  buildDate: "2026-09-23T03:00:56.556Z",
  buildId: "20260923-030056-709e573",
  gitSha: "709e573",
  version: "0.0.0",
} as const;
